import api from './api';

export interface ContractPendingSignature {
  id: number;
  contract_number: string;
  contract_date: string;
  description: string;
  employee_name: string;
  employee_email: string;
  gdoc_link: string;
  unitresco_name: string;
  unitresco_email: string;
  status: 'Oczekujące' | 'Podpisane' | 'Anulowane';
  created_by_user_id?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateContractData {
  contractNumber: string;
  contractDate: string;
  description: string;
  employeeName: string;
  employeeEmail: string;
  gdocLink: string;
  unitrescoName: string;
  unitrescoEmail: string;
}

class ContractPendingSignatureService {
  private baseURL = '/contracts-pending-signature';

  async getAllContracts(status?: string, search?: string): Promise<ContractPendingSignature[]> {
    try {
      const params: any = {};
      if (status) params.status = status;
      if (search) params.search = search;
      
      const response = await api.get(this.baseURL, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching contracts:', error);
      throw error;
    }
  }

  async createContract(data: CreateContractData): Promise<ContractPendingSignature> {
    try {
      const response = await api.post(this.baseURL, data);
      return response.data;
    } catch (error) {
      console.error('Error creating contract:', error);
      throw error;
    }
  }

  async sendSignatureLinks(contractId: number): Promise<void> {
    try {
      await api.post(`${this.baseURL}/${contractId}/send`);
    } catch (error) {
      console.error('Error sending signature links:', error);
      throw error;
    }
  }

  async generatePdf(contractId: number): Promise<{ pdfUrl: string; pdfDownloadUrl: string }> {
    try {
      const response = await api.post(`${this.baseURL}/${contractId}/generate-pdf`);
      return response.data;
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  }

  async deleteContract(contractId: number): Promise<void> {
    try {
      await api.delete(`${this.baseURL}/${contractId}`);
    } catch (error) {
      console.error('Error deleting contract:', error);
      throw error;
    }
  }

  async getSignPageData(token: string): Promise<any> {
    try {
      const response = await api.get(`${this.baseURL}/sign/${token}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sign page data:', error);
      throw error;
    }
  }

  async submitSignature(token: string, signatureData: string, accepted: boolean): Promise<void> {
    try {
      await api.post(`${this.baseURL}/sign/${token}`, {
        signatureData,
        accepted
      });
    } catch (error) {
      console.error('Error submitting signature:', error);
      throw error;
    }
  }
}

export default new ContractPendingSignatureService();

